import {Navigate} from 'react-router-dom';
import { LOGIN, PRIVATE } from 'Shared/Routing/Application/Constants/PathsConstant';
import {useAuthContext} from 'Shared/Security/Domain/Contexts/authContext';

export default function PublicRedirector() {
  const {isAuthenticated} = useAuthContext();
  if (isAuthenticated) {
    let targetPath = new URLSearchParams(window.location.search).get('targetPath');
    if (targetPath) {
      return <Navigate to={targetPath} />;
    }
    return <Navigate to={PRIVATE} />;
  }else{
    return <Navigate to={LOGIN} />;
  }
}
